// @flow
import React, { Component } from 'react';

import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';

import ClosableDialog from 'components/ClosableDialog';

import { grey100 } from 'material-ui/styles/colors';

const styles = {
  textField: {
    background: grey100,
    borderRadius: 2,
    padding: 6,
  },

  invalidMessage: {
    color: 'red',
  },

  coords: {
    fontFamily: 'monospace',
    background: '#F0F0F0',
    padding: 2,
    borderRadius: 3,
  },
};

type Props = {|
  +visible: boolean,
  +feature: object,
  +toggle: Function,
|};

export default ({ visible, feature, toggle }: Props) => (
  <ClosableDialog
    title="NOTAM részletei"
    open={visible}
    onRequestClose={() => toggle(false)}
    autoScrollBodyContent
  >
    <TextField
      floatingLabelText="NOTAM eredeti szövege"
      rows={6}
      textareaStyle={styles.textField}
      multiLine
      fullWidth
      value={
        feature && feature.raw_data
          ? `${feature.raw_data}`
          : ''
      }
    />
  </ClosableDialog>
);



// WEBPACK FOOTER //
// ./components/NotamDetailsDialog/NotamDetailsDialog.js